<template>
  <div>
    <div class="closepass-button">
      <Button
        @click="pushBack"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain"
      />
    </div>
    <div v-if="this.isLoading" class="passenger-card__skeleton-wrapper">
      <Skeleton class="passenger-card__skeleton" width="160px" height="24px" />
      <Skeleton class="passenger-card__skeleton" width="280px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="220px" height="20px" />
      <Skeleton class="passenger-card__skeleton" width="100%" height="280px" />
    </div>
    <div v-else>
      <h2 class="choose-order__card-company__sidebar-flightnum">
        {{
          "Рейс " +
          routeRules.order.Flights[0].MarketingAirline.CodeLat +
          "-" +
          routeRules.order.Flights[0].FlightNumber
        }}
      </h2>

      <p class="choose-order__card-company__sidebar-flightinfo">
        {{
          getHoursTimeInFlight(routeRules.order.Flights[0].TimeDifference) +
          "ч " +
          getMinutesTimeInFlight(routeRules.order.Flights[0].TimeDifference) +
          "м " +
          getTransportInfo(routeRules.order.Flights[0].AirCraft)
        }}
      </p>
      <p v-if="routeRules.order.Flights[0].Pnr !== null" class="choose-order__card-company__sidebar-bookingnum">
        <!-- Вставить сюда код бронирования перевозчика -->
        {{ "Код бронирования " + routeRules.order.Flights[0].Pnr }}
      </p>
      <div class="choose-order__card-company__sidebar-baggage">
        <h3 class="choose-order__card-company__sidebar-baggage__title">
          {{ "Тариф: " + routeRules.order.Flights[0].MiniRule.NameRus }}
        </h3>
        <div
          v-for="rule in routeRules.order.Flights[0].MiniRule.Parameters
            .ParamsList"
          :key="rule.ParamID"
          class="choose-order__card-company__sidebar-baggage__wrapper"
        >
          <div
            class="choose-order__card-company__sidebar-baggage__rules"
            v-if="
              rule.ParamID == 'SHLG' ||
              rule.ParamID == 'SFBG' ||
              rule.ParamID == 'SCHR' ||
              rule.ParamID == 'SRFR'
            "
          >
            <div
              class="choose-order__card-company__sidebar-baggage__rules-icon"
            >
              <img
                class="
                  choose-order__card-company__sidebar-baggage__rules-icon-image
                "
                :src="require(`../assets/images/rule-${rule.ParamID}.svg`)"
                alt=""
              />
              <img
                class="
                  choose-order__card-company__sidebar-baggage__rules-text__icon
                "
                v-if="rule.Cost == 'free'"
                :src="require(`../assets/images/check.svg`)"
              />
              <img
                class="
                  choose-order__card-company__sidebar-baggage__rules-text__icon
                "
                v-if="rule.Cost == 'charge'"
                :src="require(`../assets/images/ruble.svg`)"
              />
              <img
                class="
                  choose-order__card-company__sidebar-baggage__rules-text__icon
                "
                v-if="rule.Cost == 'not available'"
                :src="require(`../assets/images/remove.svg`)"
              />
            </div>
            <div
              class="choose-order__card-company__sidebar-baggage__rules-text"
            >
              <p
                class="
                  choose-order__card-company__sidebar-baggage__rules-text__text
                "
                v-html="`${rule.Value}`"
              ></p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="routeRules.order.Flights[0].Registration.length > 0"
        class="choose-order__card-company__sidebar-registration"
      >
        <div class="choose-order__card-company__sidebar-registration__wrapper">
          <h3 class="choose-order__card-company__sidebar-registration__title">
            Онлайн регистрация
          </h3>
          <Button
            v-if="
              routeRules.order.Flights[0].Registration[0].State == -1 ||
              routeRules.order.Flights[0].Registration[0].State == -2
            "
            label="Услуга не оказана"
            class="
              p-button-danger
              choose-order__card-company__sidebar-registration__status
            "
          />
          <Button
            v-if="routeRules.order.Flights[0].Registration[0].State == 0"
            label="Запрошена"
            class="choose-order__card-company__sidebar-registration__status"
          />
          <Button
            v-if="routeRules.order.Flights[0].Registration[0].State == 1"
            label="Пройдена"
            class="
              p-button-success
              choose-order__card-company__sidebar-registration__status
              status-succes
            "
          />
        </div>

        <div
          class="choose-order__card-company__sidebar-registration__startdate"
        >
          <p
            class="
              choose-order__card-company__sidebar-registration__startdate-title
            "
          >
            Дата начала
          </p>
          <p
            class="
              choose-order__card-company__sidebar-registration__startdate-value
            "
          >
            {{
              getAnyDate(
                routeRules.order.Flights[0].Registration[0].CheckinDate
              )
            }}
          </p>
        </div>
        <div class="choose-order__card-company__sidebar-registration__enddate">
          <p
            class="
              choose-order__card-company__sidebar-registration__enddate-title
            "
          >
            Дата окончания
          </p>
          <p
            class="
              choose-order__card-company__sidebar-registration__enddate-value
            "
          >
            {{
              getAnyDate(
                routeRules.order.Flights[0].Registration[0].CheckinFinishDate
              )
            }}
          </p>
        </div>
        <div
          class="choose-order__card-company__sidebar-registration__cabin"
          v-if="routeRules.order.Flights[0].Registration[0].CabinPrefs !== -1"
        >
          <p
            class="
              choose-order__card-company__sidebar-registration__cabin-title
            "
          >
            Предпочтения по салону
          </p>
          <p
            class="
              choose-order__card-company__sidebar-registration__cabin-value
            "
            v-if="routeRules.order.Flights[0].Registration[0].CabinPrefs == 0"
          >
            Любое место
          </p>
          <p
            class="
              choose-order__card-company__sidebar-registration__cabin-value
            "
            v-if="routeRules.order.Flights[0].Registration[0].CabinPrefs == 1"
          >
            В начале салона
          </p>
          <p
            class="
              choose-order__card-company__sidebar-registration__cabin-value
            "
            v-if="routeRules.order.Flights[0].Registration[0].CabinPrefs == 2"
          >
            Посередине салона
          </p>
          <p
            class="
              choose-order__card-company__sidebar-registration__cabin-value
            "
            v-if="routeRules.order.Flights[0].Registration[0].CabinPrefs == 3"
          >
            В конце салона
          </p>
        </div>
        <div
          class="choose-order__card-company__sidebar-registration__seat"
          v-if="routeRules.order.Flights[0].Registration[0].SeatPrefs !== -1"
        >
          <p
            class="choose-order__card-company__sidebar-registration__seat-title"
          >
            Предпочтения по месту
          </p>
          <p
            class="choose-order__card-company__sidebar-registration__seat-value"
            v-if="routeRules.order.Flights[0].Registration[0].SeatPrefs == 0"
          >
            Любое место
          </p>
          <p
            class="choose-order__card-company__sidebar-registration__seat-value"
            v-if="routeRules.order.Flights[0].Registration[0].SeatPrefs == 1"
          >
            У окна
          </p>
          <p
            class="choose-order__card-company__sidebar-registration__seat-value"
            v-if="routeRules.order.Flights[0].Registration[0].SeatPrefs == 2"
          >
            Средний ряд
          </p>
          <p
            class="choose-order__card-company__sidebar-registration__seat-value"
            v-if="routeRules.order.Flights[0].Registration[0].SeatPrefs == 3"
          >
            У прохода
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ref } from "vue";
import useClipboard from "vue-clipboard3";
import Button from "primevue/button";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "RouteCardInfo",
  components: {
    Button,
    Skeleton,
  },
  props: ["order", "flightId"],
  setup(props) {
    const isLoading = ref(false);
    const error = ref(null);
    const router = useRouter();
    const route = useRoute();
    const routeRules = ref(null);
    const getRouteInfo = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetFlightRuleInfo?guid=${props.order}&flightId=${props.flightId}`
        );
        let fetchedPass = await json.data;
        routeRules.value = fetchedPass;
        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    return {
      isLoading,
      error,
      routeRules,
      getRouteInfo,
    };
  },
  data() {
    return {
      hoursWords: ["час", "часа", "часов"],
      minutesWords: ["минута", "минуты", "минут"],
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    getHoursTimeInFlight(time: any) {
      let flightHours = 0;
      let splited = time.split(":");
      flightHours += +splited[0];
      return flightHours;
    },
    getMinutesTimeInFlight(time: any) {
      let flightMinutes = 0;
      let splited = time.split(":");
      flightMinutes += +splited[1];
      return flightMinutes;
    },
    declOfHours(number: any, words: any) {
      return words[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
      ];
    },
    getAnyDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getTransportInfo(item: any) {
      if (item.Id === 7) {
        return "в пути на автобусе";
      } else if (item.Id === 436) {
        return "в пути на поезде";
      } else {
        return "в полёте на " + item.NameRus;
      }
    },
    pushBack() {
      this.$router.back();
    },
  },
  created() {
    this.getRouteInfo();
  },
});
</script>

<style>
.choose-order__card-company__sidebar {
  margin: 0 0 0 auto;
}

.p-sidebar {
  background-color: #e9e9e9 !important;
}

.choose-order__card-company__sidebar-flightnum {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.choose-order__card-company__sidebar-bookingnum {
  color: #666666;
  margin-top: 5px;
}

.choose-order__card-company__sidebar-flightinfo {
  color: #666666;
  margin-top: 5px;
}

.choose-order__card-company__sidebar-baggage {
  margin-top: 10px;
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 10px 10px 10px 15px;
}

.choose-order__card-company__sidebar-baggage__title {
  font-size: 18px;
  font-weight: normal;
}

.choose-order__card-company__sidebar-baggage__rules {
  margin-top: 15px;
  display: flex;
  align-items: center;
}

.choose-order__card-company__sidebar-baggage__rules-icon {
  position: relative;
}

.choose-order__card-company__sidebar-baggage__rules-icon-image {
  width: 40px;
  height: 40px;
}

.choose-order__card-company__sidebar-baggage__rules-text__icon {
  position: absolute;
  width: 20px;
  height: 20px;
  font-size: 20px;
  top: 25px;
  left: 10px;
}

.choose-order__card-company__sidebar-baggage__rules-text {
  margin-left: 10px;
}

.choose-order__card-company__sidebar-baggage__rules-text__text {
  color: #000;
  position: relative;
}

.choose-order__card-company__sidebar-registration {
  margin-top: 25px;
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 10px 10px 10px 15px;
}

.choose-order__card-company__sidebar-registration__wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}

.choose-order__card-company__sidebar-registration__title {
  margin-bottom: 15px;
  margin-right: 5px;
}

.choose-order__card-company__sidebar-registration__status {
  margin-bottom: 15px !important;
}

.choose-order__card-company__sidebar-registration__startdate {
  display: flex;
  justify-content: space-between;
}

.choose-order__card-company__sidebar-registration__startdate-value {
  color: #000;
}

.choose-order__card-company__sidebar-registration__enddate {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.choose-order__card-company__sidebar-registration__enddate-value {
  color: black;
}

.choose-order__card-company__sidebar-registration__cabin {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.choose-order__card-company__sidebar-registration__cabin-value {
  color: #000;
}

.choose-order__card-company__sidebar-registration__seat {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.choose-order__card-company__sidebar-registration__seat-value {
  color: #000;
}

.choose-order__card-company__sidebar-registration__link {
  margin-top: 10px;
}

.choose-order__card-company__sidebar-registration__link-title {
  margin-bottom: 8px;
}

.choose-order__card-company__sidebar-registration__link-text {
  color: #000;
  margin-top: 8px;
}

.rule-hint {
  color: cornflowerblue;
  text-decoration: underline;
}

.rule-hint[original-title]:hover::before {
  content: attr(original-title);
  position: absolute;
  left: 0;
  bottom: 0px;
  display: inline-block;
  padding: 3px 6px;
  border-radius: 2px;
  background: rgb(138, 204, 243);
  color: #000;
  font-size: 12px;
  min-width: 250px;
  font-family: sans-serif;
  white-space: normal;
  z-index: 5;
}
</style>
